// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cc323ca9","239":"1bb8e5f7","732":"dcf647d6"}[chunkId] + ".chunk.js";
};